import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMe } from '@/api/auth';
import { useAuthStore } from '@/stores/authStore';

export function useAuth() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const setUser = useAuthStore((s) => s.setUser);
  const role = useAuthStore((s) => s.role);
  const approved = useAuthStore((s) => s.approved);

  useEffect(() => {
    if (import.meta.env.VITE_AUTH_DISABLED === 'true') {
      setUser({ role: 'admin', userId: 'local-dev', email: 'admin@localhost', phone: null, approved: true });
      setLoading(false);
      return;
    }
    getMe()
      .then((user) => {
        if (!user.approved) {
          navigate('/login', { replace: true });
          return;
        }
        setUser({
          role: user.role,
          userId: user.user_id,
          email: user.email,
          phone: user.phone,
          approved: user.approved,
        });
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        navigate('/login', { replace: true });
      });
  }, [navigate, setUser]);

  return { loading, error, role, approved };
}
